import React from 'react';

import { useTranslationX } from 'i18n';
import Dialog, { DialogProps } from './Dialog';
import { useVisible } from 'components/hooks';
import { Button } from 'components/elements';
import { Info } from 'components/icons';

import styles from './InfoDialog.module.scss';

type Props = {
  visible: boolean;
  buttonLabel?: string;
  onSubmit?: () => void;
};

const InfoDialog: React.FC<Props & DialogProps> = props => {
  const { buttonLabel, onSubmit, ...rest } = props;
  const { visible, setVisible } = useVisible(props.visible);

  const { tx } = useTranslationX('button');

  function onClick() {
    setVisible(false);
    onSubmit && onSubmit();
  }

  return (
    <Dialog
      {...rest}
      visible={visible}
      icon={Info}
      iconProps={{ className: styles.info }}
      actions={
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button onClick={onClick}>{buttonLabel || tx('ok')}</Button>
        </div>
      }
    />
  );
};

export default InfoDialog;
